import { createTheme, responsiveFontSizes } from '@mui/material'
import { defaultThemeOptions, StatusColor } from 'themes/modes/common_theme'

/**
 * comstruct Light Mode Theme
 * @category Themes
 */
export const lightModeTheme = responsiveFontSizes(
  createTheme(defaultThemeOptions)
)

/**
 * comstruct Light Mode Status Color
 * @category Themes
 */
export const lightStatusColor: StatusColor = {
  DEFAULT: lightModeTheme.palette.background.default,
  SUCCESS: lightModeTheme.palette.success.light,
  ERROR: lightModeTheme.palette.error.light,
  INFO: lightModeTheme.palette.info.light,
  WARNING: lightModeTheme.palette.warning.light,
}
